const OLD_PRICING_TABLE_VERSION = '1.9.12-sbf3';
const UNLEASH_FLAG = 'AbNewPricingTesting';
const isAbTestingDisabled = true;
const injectABTestContext = () => {
  const variant = window?.unleash_client?.getVariant?.(UNLEASH_FLAG);
  const pricingTableElement = document.getElementById('pricing-table');
  if (variant?.enabled && pricingTableElement) {
    pricingTableElement.setAttribute('data-ab-test-name', UNLEASH_FLAG);
    pricingTableElement.setAttribute('data-ab-test-variant', variant.name);
    const eventAlreadySent = window.dataLayer?.some(item => item.event === 'ab_test_event' && item.test_name === UNLEASH_FLAG && item.test_variant === variant.name);
    if (!eventAlreadySent && window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({
        event: 'ab_test_event',
        test_name: UNLEASH_FLAG,
        test_variant: variant.name
      });
    }
  }
};
const selectVersion = () => {
  const newVersion = window.PRICING_TABLE_VERSION;
  if (isAbTestingDisabled) {
    return newVersion;
  }
  const variant = window?.unleash_client?.getVariant?.(UNLEASH_FLAG);
  const wantsNew = variant?.name === 'new' && variant?.enabled;
  if (wantsNew && newVersion) {
    return newVersion;
  } else {
    return OLD_PRICING_TABLE_VERSION;
  }
};
const dispatchReady = version => {
  window.SELECTED_PRICING_TABLE_VERSION = version;
  window.dispatchEvent(new CustomEvent('pricingTableVersionReady'));
};
const initNewPricingTableABTesting = () => {
  let resolved = false;
  const resolve = () => {
    if (resolved) return;
    dispatchReady(selectVersion());
    resolved = true;
    injectABTestContext();
  };
  if (window?.unleash_client?.isReady?.()) {
    resolve();
    return;
  }
  const timeoutId = setTimeout(() => {
    if (resolved) return;
    console.warn('Unleash client timeout – falling back to selectVersion().');
    dispatchReady(selectVersion());
    resolved = true;
  }, 5_000);
  window?.unleash_client?.on?.('update', () => {
    if (resolved) return;
    clearTimeout(timeoutId);
    resolve();
  });
};
module.exports = {
  initNewPricingTableABTesting
};